import axios from "axios";
import { resolveToken, removeSessionToken } from "./tokenStorage.js";

const api = axios.create({
  baseURL: import.meta.env.VITE_API_BASE_URL || "/api",
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  // Resolve tenantId from the x-tenant-id header already on the request,
  // or fall back to sessionStorage (legacy magic-link path).
  const tenantId =
    config.headers?.["x-tenant-id"] ||
    sessionStorage.getItem("webapp_tenant_id") ||
    null;

  const token = resolveToken(tenantId);
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  if (tenantId) config.headers["x-tenant-id"] = tenantId;

  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    const status = error.response?.status;
    const code = error.response?.data?.error?.code;

    if (status === 401 && code === "TOKEN_EXPIRED") {
      removeSessionToken();
    }

    return Promise.reject(error);
  }
);

export default api;
